import { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image, Typography, Row, Col } from 'antd';
import type { UploadFile, RcFile } from 'antd/es/upload';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
// import mobileIcon from 'assets/images/mobile-icon.svg';
import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
// import { Attachments } from 'types';
// import { EnquirySuccessPage } from '../SubmitAfterConfirm-bak';
import { Spinner } from 'components';
import type { InputRef } from 'antd';
import { EnquirySuccessPage } from './OtpVerificationSuccessPage';

// import { ActionType, RegistrationFlowContext } from 'contexts/registration';
import { Card, InvalidTextMsg, ResendCaptchaSection, SubTitle, NewInput } from './styledComponents';
import { getConfig } from 'configs';
import GoogleCaptcha from '../../../../components/googleCaptcha';
import {
  ApiFetcherError,
  useRequestOtp,
  useValidateOtp,
  useEmailOtp,
  useEmailOtpValidate,
  useLifeUserProfile,
  PostClaimCIData,
  usePostClaimCI,
} from 'all-in-one-shared-api';

const { Title, Text, Link } = Typography;

const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

interface LocationState {
  allData: PostClaimCIData;
}
export const CIOtpVerificationPage = (): JSX.Element => {
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  const { token, tokenParsed } = useKeycloakReady();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [mobile, setmobile] = useState<string>();
  const [email, setemail] = useState<string>();
  const [countryCode, setcountryCode] = useState<string>();
  const [areaCode, setAreaCode] = useState<string>();
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  const [startLoading, setloding] = useState(false);
  const location = useLocation();
  const [enquiryReference, setEnquiryReference] = useState('');
  const { allData } = (location.state as LocationState) ?? {};
  const [showTips, setShowTips] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const { shouldFetch: profileshouldFetch, data: profileInfoData } = useLifeUserProfile(
    'useLifeUserProfile',
    token || '',
  );
  useEffect(() => {
    profileshouldFetch(true);
    if (profileInfoData) {
      setmobile(profileInfoData.mobile);
      setemail(profileInfoData.email);
      setcountryCode(profileInfoData.countryCode);
      setAreaCode(profileInfoData.areaCode);
    }
  }, [profileshouldFetch, profileInfoData]);
  const loginId = tokenParsed?.preferred_username;
  const mobileNumber = (countryCode ?? '') + (areaCode ?? '') + (mobile ?? '');
  const [key, setKey] = useState<string>('678687678687');
  const [validateKey, setValidateKey] = useState<string>('');
  const [randoms, setRandoms] = useState(Math.random());
  const { shouldFetch /*, isLoading */ } = useRequestOtp(key, loginId ?? '', mobileNumber, {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldFetch(false);
    },
    onError: (error) => {
      if (error) {
        shouldFetch(false);
        const apiError = error as ApiFetcherError;
        setErrorMsg(apiError.code ? apiError.code : error.message);
      }
    },
  });
  const { shouldFetch: shouldEmailFetch } = useEmailOtp(key, loginId ?? '', email ?? '', {
    shouldRetryOnError: false,
    onSuccess: () => {
      shouldEmailFetch(false);
    },
    onError: (error) => {
      if (error) {
        shouldEmailFetch(false);
        const apiError = error as ApiFetcherError;
        setErrorMsg(apiError.code ? apiError.code : error.message);
      }
    },
  });
  // 将 policyNumber 按逗号拆分成数组，每个值单独调用接口
  const policyNumbers = useMemo(() => {
    if (!allData?.policyNumber) return [];
    return allData.policyNumber
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }, [allData]);
  const [currentPolicyIndex, setCurrentPolicyIndex] = useState(0);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const bpmReferenceNosRef = useRef<string[]>([]);

  // 构造当前需要提交的 allData，只传单个 policyNumber，并将 UploadFile 转为 originFileObj
  const currentAllData = useMemo((): PostClaimCIData | undefined => {
    if (!allData) return undefined;

    const fieldNames = [
      'criticalIllnessClaimFormAttachments',
      'proofOfIdentityAttachments',
      'laboratoryAndPathologicalAttachments',
      'otherAttachments',
      'pepAttachments',
    ] as const;

    const policyNumber =
      policyNumbers.length > 0 && currentPolicyIndex < policyNumbers.length
        ? policyNumbers[currentPolicyIndex]
        : allData.policyNumber;

    // 将 UploadFile[] 中的 originFileObj 提取为 RcFile
    type CIFileFields = Pick<PostClaimCIData, typeof fieldNames[number]>;
    const fileFields = {} as CIFileFields;
    for (const field of fieldNames) {
      const fieldValue = allData[field];
      if (Array.isArray(fieldValue)) {
        fileFields[field] = fieldValue.map((f) => ((f as UploadFile).originFileObj ?? undefined) as RcFile | undefined);
      }
    }

    return {
      ...allData,
      policyNumber,
      ...fileFields,
    } as PostClaimCIData;
  }, [allData, policyNumbers, currentPolicyIndex]);

  const {
    data: responseMessage,
    error: requestError,
    shouldFetch: shouldRequestFetch,
  } = usePostClaimCI({ name: 'usePostClaimCI' + randoms }, token ?? '', { ...currentAllData } as PostClaimCIData);

  // 触发下一次接口请求
  useEffect(() => {
    if (triggerFetch) {
      shouldRequestFetch(true);
      setTriggerFetch(false);
    }
  }, [triggerFetch, shouldRequestFetch]);

  useEffect(() => {
    if (responseMessage) {
      shouldRequestFetch(false);
      bpmReferenceNosRef.current = [...bpmReferenceNosRef.current, responseMessage.bpmReferenceNo];

      if (policyNumbers.length > 0 && bpmReferenceNosRef.current.length < policyNumbers.length) {
        // 还有下一个 policyNumber，继续调用
        setCurrentPolicyIndex(bpmReferenceNosRef.current.length);
        setRandoms(Math.random());
        setTriggerFetch(true);
      } else {
        // 所有 policyNumber 都已处理完毕
        setEnquiryReference(bpmReferenceNosRef.current.join(', '));
        setIsDone(true);
        setloding(false);
      }
    }
  }, [responseMessage, shouldRequestFetch, setIsDone, policyNumbers]);
  useEffect(() => {
    if (requestError) {
      shouldRequestFetch(false);
      setloding(false);
      navigate('/ChangeRequestError', {
        replace: true,
      });
    }
  }, [requestError, shouldRequestFetch, i18n, navigate]);
  const { shouldFetch: shouldEmailValidate } = useEmailOtpValidate(validateKey, loginId ?? '', otpArray, {
    shouldRetryOnError: false,
    onSuccess: (validateResponse) => {
      shouldEmailValidate(false);
      if (validateResponse) {
        if (validateResponse.success) {
          setErrorMsg(null);
          setloding(true);
          bpmReferenceNosRef.current = [];
          setCurrentPolicyIndex(0);
          setRandoms(Math.random());
          shouldRequestFetch(true);
        } else {
          //光標移入第一個輸入框
          if (digit1InputRef.current) {
            digit1InputRef.current.focus();
          } else {
            console.error('digit1InputRef.current is null');
          }
          setOtpArray('');
          setErrorMsg(validateResponse.message);
        }
      }
    },
  });

  const { shouldFetch: shouldValidateOtp } = useValidateOtp(validateKey, loginId ?? '', otpArray, {
    shouldRetryOnError: false,
    onSuccess: (validateResponse) => {
      shouldValidateOtp(false);
      if (validateResponse) {
        if (validateResponse.success) {
          setErrorMsg(null);
          setloding(true);
          bpmReferenceNosRef.current = [];
          setCurrentPolicyIndex(0);
          setRandoms(Math.random());
          shouldRequestFetch(true);
        } else {
          //光標移入第一個輸入框
          if (digit1InputRef.current) {
            digit1InputRef.current.focus();
          } else {
            console.error('digit1InputRef.current is null');
          }
          setOtpArray('');
          setErrorMsg(validateResponse.message);
        }
      }
    },
  });

  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);
  const handleResendOtp = () => {
    if (!showTips) setShowTips(true);

    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }

    // setOtpInput("");
    setRequestOtpCount(requestOtpCount + 1);
    console.log('onPressResend()->');
    setKey(generateKey());

    setOtpArray('');
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }

    // setResendCountdown(RESEND_COUNTDOWN_PERIOD);
    // startResendCountdown();
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  };

  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount, setIsShowCaptcha]);
  useEffect(() => {
    setKey(generateKey());
    // 如果email存在，那麼shouldEmailFetch(true),否則shouldFetch(true)
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  }, [email, mobile, shouldFetch, shouldEmailFetch, location]);
  const handleVerifyOtp = useCallback(() => {
    if (!/\d{6}/.test(otpArray)) {
      setErrorMsg(t('smsOtpVerification.code-not-found'));
      return;
    }
    setValidateKey(generateKey());
    if (email) {
      shouldEmailValidate(true);
    } else if (mobile) {
      shouldValidateOtp(true);
    }
  }, [otpArray, email, mobile, setErrorMsg, setValidateKey, shouldEmailValidate, shouldValidateOtp, t]);
  useEffect(() => {
    if (otpArray.length === 6) {
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorMsg && errorMsg == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);

      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
    }
  }, [countdown]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setErrorMsg(t('login.error.captchaDigitError'));
  };

  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setErrorMsg(null);
  };
  function maskEmail(email: string) {
    if (!email) return '';
    // ???????????????
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');

    // ???????,???1???1?,???*??
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
    // ??????????
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    // ???3???4?,???*??
    const visibleDigits = 2; // ????,??????????
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    // ?????*?????
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    // ??????????
    return startDigits + maskedPart + endDigits;
  }

  const didRewriteRef = useRef(false);
  useEffect(() => {
    if (!isDone || didRewriteRef.current) {
      return;
    }
    didRewriteRef.current = true;
    const currentPath = location.pathname + (location.search || '');
    const currentState = location.state;
    navigate('/ClaimEnquiryPage', { replace: true, state: { tabs: 1 } });
    navigate(currentPath, { state: currentState });
    // eslint-disable-next-line
  }, [isDone, navigate]);
  if (isDone) {
    return <EnquirySuccessPage enquiryReference={enquiryReference} />;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        paddingLeft: '40px',
        paddingRight: '40px',
      }}
    >
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#20252b', fontWeight: '400' }}
      >
        {t('life.submitClaims.otpTitle')}
      </Typography.Title>
      <div
        className="register_otp_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
        }}
      >
        <Card style={{ border: 0, width: '100%', maxWidth: '400px' }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Title level={3}>{t('smsOtpVerification.screenTitle')}</Title>
            </Col>
            {!email && showTips && (
              <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                <Title level={3} style={{ fontSize: '20px', color: 'red' }}>
                  {t('sms.othersOtpLife')}
                </Title>
              </Col>
            )}
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image
                height="10.25rem"
                src={email ? emailIcon : mobileIcon}
                preview={false}
                style={{ height: '153px' }}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{
                  display: 'inline-block',
                  textAlign: 'center',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  color: '#6f7072',
                }}
              >
                {email ? t('smsOtpVerification.emailScreenSubtitle') : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {email
                  ? maskEmail(email)
                  : mobile
                  ? countryCode + '  ' + (areaCode ? `${areaCode} ` : '') + maskPhoneNumber(mobile)
                  : null}
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ textAlign: 'center' }}>
              {errorMsg && <InvalidTextMsg type="danger">{t(errorMsg)}</InvalidTextMsg>}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection style={{ fontSize: '20px', width: '340px' }}>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    <Link
                      onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                      style={{
                        fontFamily: 'Roboto400',
                        fontSize: '17px',
                        pointerEvents: countdown > 0 ? 'none' : 'auto',
                        color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                      }}
                    >
                      {t('smsOtpVerification.resend')}
                    </Link>
                    {countdown >= 0 && (
                      <Text type="secondary" style={{ fontFamily: 'Roboto400', fontSize: '17px' }}>
                        {t('smsOtpVerification.resendCountdownText', {
                          second: countdown,
                        })}
                      </Text>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
              {startLoading && <Spinner />}
            </Col>

            <Link
              onClick={() => {
                navigate(-1);
              }}
              style={{
                fontWeight: 'normal',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
                fontFamily: 'Roboto400',
                fontSize: '17px',
              }}
            >
              {t('life.enquiry.Cancel')}
            </Link>
          </Row>
        </Card>
      </div>
    </div>
  );
};
